export const getRangeFieldValue = (rangeRef: any, valueId: string) => {
  let value: any = {} as { [id: string]: string };
  const rangeKeys = ['From', 'To'];
  rangeKeys.forEach(key => {
    if (rangeRef && Object.keys(rangeRef).length > 0) {
      value[key.toLowerCase()] = rangeRef[key].current[`${key}.${valueId}`].value;
    }
  });
  return value;
}